export default __webpack_public_path__ + "static/media/Logo_transparent.c05d3f55.svg";